<template>
  <div class="group grid gap-4 md:grid-cols-2 [&:not(:first-child)]:mt-5">
    <slot />
  </div>
</template>
